<script>

import store from '@/store'
import router from '@/router'
import eventBus from '@/plugins/event-bus'

export default {
    name: "AutoLogout",
    data() {
        return {
            warningTimer: null,
            logoutTimer: null,
            starter: false,
        }
    },
    setup () {
        let sessionLogoutMinutes = store.state.token.validitySessionMinutes
        if(!sessionLogoutMinutes) sessionLogoutMinutes = 2
        
        const sessionLogoutSeconds = sessionLogoutMinutes * 60
        const sessionWarningSeconds = sessionLogoutMinutes * 60 - 20

        return {
            sessionLogoutSeconds,
            sessionWarningSeconds,
        }
    },
    mounted() {
        eventBus.on('refresh-validity-session', (validitySessionMinutes) => {
            this.sessionLogoutSeconds = validitySessionMinutes * 60
            this.sessionWarningSeconds = validitySessionMinutes * 60 - 20

            this.resetTimer()
        });

        if(store.state.auth.status.loggedIn)
        {
            this.setTimers()
            this.starter = true
        }
    },
    watch: {
        "$store.state.auth.status.loggedIn"(loggedIn) {
            if(loggedIn)
            {
                this.setTimers()
                this.starter = true
            }
            else
            {
                clearTimeout(this.warningTimer)
                clearTimeout(this.logoutTimer)
                this.starter = false
            }
        },
    },
    methods: {
        setTimers() {
            this.warningTimer = setTimeout(() => {
                this.warningMessage()
            }, this.sessionWarningSeconds * 1000)

            this.logoutTimer = setTimeout(() => {
                this.logoutUser()
            }, this.sessionLogoutSeconds * 1000)
        },

        warningMessage() {
            this.$moshaToast('La session va expirer et vous allez être déconnecté', {
                timeout: 5000,
                hideProgressBar: true,
                type: 'warning',
                swipeClose: true,
                position: 'top-center',
            })
        },

        logoutUser() {
            store.dispatch('auth/logout');
            if(localStorage.getItem('account_name'))
                router.push({name: 'login_account'})
            else
                router.push({name: 'login'})

            clearTimeout(this.warningTimer)
            clearTimeout(this.logoutTimer)
            this.starter = false
        },

        resetTimer() {
            clearTimeout(this.warningTimer)
            clearTimeout(this.logoutTimer)

            this.setTimers()
        }
    }
};

</script>

<template>
    <div></div>
</template>
